import { ConfigurationAssaygroupLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/services/configuration-assaygroup-laboratory/configuration-assaygroup-laboratory.dto'

export interface ConfigurationLocalAssaysGroupsModalState {
    assaygroupLaboratory: Partial<ConfigurationAssaygroupLaboratoryResponse>
}
export const initialConfigurationLocalAssaysGroupsModalState =
    (): ConfigurationLocalAssaysGroupsModalState => ({
        assaygroupLaboratory: {}
    })
